const TIPOS_VERTICAL = [
  'apartamento', 'kitnet', 'loft', 'cobertura', 'flat', 'studio', 'studi',
];

const TIPOS_HORIZONTAL = [
  'casa', 'sobrado', 'terreno', 'lote', 'chácara', 'chacara',
  'fazenda', 'sítio', 'sitio',
];

export function deriveFormatoLaudo(
  tipoImovel: string | undefined | null,
): 'HORIZONTAL' | 'VERTICAL' {
  const tipo = (tipoImovel ?? '').toLowerCase().trim();
  if (!tipo) return 'VERTICAL';
  if (TIPOS_VERTICAL.some(t => tipo.includes(t))) return 'VERTICAL';
  if (TIPOS_HORIZONTAL.some(t => tipo.includes(t))) return 'HORIZONTAL';
  return 'VERTICAL';
}

export function normalizeFormatoLaudo(
  raw: string | undefined | null,
): 'HORIZONTAL' | 'VERTICAL' | null {
  const v = (raw ?? '').toUpperCase().trim();
  if (v === 'HORIZONTAL' || v === 'VERTICAL') return v;
  return null;
}
